import axios from 'axios';
import Cookies from 'js-cookie';
import { createBrowserHistory } from 'history';
import PasswordHasher from '../utils/PasswordHasher';
const history = createBrowserHistory();

const authAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }

});

// authAxios.interceptors.response.use(
//     response => response,
//     error => {
//         let errorMessage = 'Unknown error occurred';
//         if (error.message === 'Network Error') {
//             errorMessage = 'Network Error - make sure API server is running.';
//         } else if (error.code === 'ECONNABORTED') {
//             errorMessage = 'A timeout happened on the URL: ' + error.config.url;
//         } else if (error.response) {
//             errorMessage = `Error: ${error.response.status} - ${error.response.statusText}`;
//         }
//         // console.log("errorMessage ============= ", errorMessage);
//         history.push({
//             pathname: '/error',
//             state: { errorMessage }
//         });
//       return Promise.reject(error);
//     }
// );

class AuthService {
    async getAuth(username, password) {
        let accessToken = sessionStorage.getItem('AuthInfo');
        
        // Hash the password before sending to server
        const hashedPassword = PasswordHasher.hashWithUsername(password, username);
        
        return await  authAxios.post("/apis/subscription/v1/auth", {
            username,
            password: hashedPassword,
            isHashed: true  // Flag to indicate password is hashed
        }).then(response => {
            if (response.status === 200) 
            {
                accessToken = response.headers.token ? response.headers.token : response.data.token;

                if (!accessToken) {
                    this.logout();
                }
                sessionStorage.setItem("AuthInfo", accessToken);
            }
            return accessToken;
        });
    }


    async logout() {
        const accessToken = sessionStorage.getItem('AuthInfo'); // Retrieve the token from sessionStorage
    
        return await authAxios.post("/apis/subscription/v1/logout", {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        }).then(response => {
            sessionStorage.clear();
            localStorage.removeItem('AuthInfo');
            document.cookie.split(";").forEach((c) => {
                document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            window.location.href = '/';
            return response.data;
        }).catch(error => {
            console.error('Logout failed', error);
            throw error;
        });
    }



}

export default new AuthService();